import { Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, of } from 'rxjs';
import { FuseNavigationItem } from '@fuse/components/navigation';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);

    // Static navigation to remove backend dependency
    private readonly _defaultItems: FuseNavigationItem[] = [
        {
            id: 'home',
            title: 'Home',
            type: 'basic',
            icon: 'heroicons_outline:home',
            link: '/home',
        },
        {
            id: 'service-mapping',
            title: 'Service Mapping',
            type: 'basic',
            icon: 'heroicons_outline:wrench-screwdriver',
            link: '/service-mapping',
        },
        {
            id: 'task-mapping',
            title: 'Task Mapping',
            type: 'basic',
            icon: 'heroicons_outline:clipboard-document-list',
            link: '/task-mapping',
        },
        {
            id: 'package-management',
            title: 'Package Management',
            type: 'basic',
            icon: 'heroicons_outline:bolt',
            link: '/package-management',
        },
        {
            id: 'order-history',
            title: 'Orders',
            type: 'basic',
            icon: 'heroicons_outline:clock',
            link: '/order-history',
        },
        // {
        //     id: 'coupon',
        //     title: 'Coupons',
        //     type: 'basic',
        //     icon: 'heroicons_outline:ticket',
        //     link: '/coupon',
        // },
        {
            id: 'workforce',
            title: 'Workforce Management',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/workforce-management',
        },
        {
            id: 'vendor-unavailability',
            title: 'Unavailability',
            type: 'basic',
            icon: 'heroicons_outline:calendar',
            link: '/vendor-unavailability',
        },
        {
            id: 'commission',
            title: 'Commission Details',
            type: 'basic',
            icon: 'heroicons_outline:banknotes',
            link: '/commission',
        },
        // {
        //     id: 'document-upload',
        //     title: 'Document Upload',
        //     type: 'basic',
        //     icon: 'heroicons_outline:document-arrow-up',
        //     link: '/document-upload',
        // },
    ];

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        const navigation: Navigation = {
            default: this._defaultItems,
            compact: this._defaultItems,
            futuristic: this._defaultItems,
            horizontal: this._defaultItems,
        };

        this._navigation.next(navigation);
        return of(navigation);
    }
}
